// extracted by mini-css-extract-plugin
module.exports = {"var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","container":"container--819f0","tripleBtn":"tripleBtn--9a0e7"};